export default {
  header: 'Make all the right money moves',
  content:
    'Need expert money advice, helpful tools and tailored insights to answer your money questions? Turn to the Nerds.',
};
